import { OverlayContainer } from '@react-aria/overlays'
import { createRoot } from 'react-dom/client'
import EnableCookies from 'screens/LoginOrSignup/components/EnableCookies/EnableCookies'
import Styles from 'App.module.scss'
import 'styles'

if (!navigator.cookieEnabled) {
  const container = document.getElementById('root')
  const root = createRoot(container!) // eslint-disable-line @typescript-eslint/no-non-null-assertion
  root.render(
    <OverlayContainer className={Styles.overlayContainer}>
      <EnableCookies />
    </OverlayContainer>,
  )
}
